<template>
  <v-row>
    <v-col cols="12">
      <addons />
    </v-col>
  </v-row>
</template>

<script>
import Addons from '@/components/Services/Hosting/Common/HostingAddons'

export default {
  name: 'AddonsView',
  components: { Addons }
}
</script>
